// Cache sprite LRU + anggaran lukis per frame (batas memori bitmap, bukan jumlah) — dipakai sprite kendaraan (traffic.js) & karakter (npcSprite.js).
// Sebelumnya cache di-`clear()` massal saat penuh → puluhan paintCode dieksekusi ulang dalam 1 frame = hentakan
// berkala (terasa "patah-patah" pada kendaraan di HP, hanya pada zoom yang memakai sprite). Kini entri terlama
// dibuang satu-satu, dan bila anggaran frame habis, sprite zoom-bucket terdekat dipakai sementara (diskalakan).
export function createLruSprite(maxBytes) {
  const m = new Map(); let bytes = 0;
  const ukuran = v => (v.cv.width * v.cv.height * 4) || 0;
  return {
    get(k) { const v = m.get(k); if (v !== undefined) { m.delete(k); m.set(k, v); } return v; }, // sentuh = jadi termuda
    set(k, v) {
      m.set(k, v); bytes += ukuran(v);
      while (bytes > maxBytes && m.size > 1) { const k0 = m.keys().next().value; bytes -= ukuran(m.get(k0)); m.delete(k0); }
    },
    // Sprite dengan prefix sama (aset|arah|malam|fase|) pada zoom-bucket terdekat — pengganti sementara saat anggaran habis
    nearest(prefix, zb) {
      let best = null, bd = Infinity;
      for (const [k, v] of m) if (k.startsWith(prefix)) { const d = Math.abs(v.zb - zb); if (d < bd) { bd = d; best = v; } }
      return best;
    },
  };
}

// Anggaran paintCode baru per frame (bersama kendaraan + karakter); engine memanggil resetAnggaranSprite() tiap frame
const anggaran = { sisa: Infinity };
export const PAINT_PER_FRAME = 5;
export function resetAnggaranSprite() { anggaran.sisa = PAINT_PER_FRAME; }
export function bolehLukis() {
  if (anggaran.sisa <= 0) return false;
  anggaran.sisa--; return true;
}
